"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const components_1 = require("@alcumus/components");
const styles_1 = require("@material-ui/core/styles");
const icons_1 = require("@material-ui/icons");
const clsx_1 = __importDefault(require("clsx"));
const useStyles = (0, styles_1.makeStyles)((theme) => (0, styles_1.createStyles)({
    dropdown: {
        display: 'flex',
        borderRadius: theme.spacing(1),
        height: theme.spacing(4),
    },
    menuItem: {
        justifyContent: 'space-between',
        padding: '8px 12px',
        '&.Mui-selected': {
            backgroundColor: components_1.StyleVariables.colors.surface.selected,
            '& svg': {
                display: 'inline',
            },
            '&:hover': {
                backgroundColor: components_1.StyleVariables.colors.surface.selected,
            },
        },
        '&:not(.Mui-selected)': {
            '&:focus': {
                backgroundColor: 'transparent',
            },
        },
        '&.MuiInputBase-input': {
            '&:hover': {
                backgroundColor: 'transparent',
            },
        },
        '&:hover': {
            backgroundColor: components_1.StyleVariables.colors.grey2,
        },
    },
    icon: {
        color: components_1.StyleVariables.colors.grey4,
    },
    checkIcon: {
        color: components_1.StyleVariables.colors.interactive.default,
        display: 'none',
    },
    root: {
        boxShadow: `0 2px 8px ${components_1.StyleVariables.colors.boxShadowGrey}`,
        borderRadius: theme.spacing(1),
        border: `1px solid ${components_1.StyleVariables.colors.border.default}`,
    },
    placeholder: {
        color: components_1.StyleVariables.colors.grey4,
    },
}));
const useOutlinedInputStyles = (0, styles_1.makeStyles)(() => ({
    root: {
        '&:hover $notchedOutline': {
            border: `1px solid ${components_1.StyleVariables.colors.interactive.default}`,
        },
        '&$focused $notchedOutline': {
            border: `1px solid ${components_1.StyleVariables.colors.interactive.default}`,
        },
    },
    focused: {},
    notchedOutline: {},
}));
const SingleSelectDropdown = ({ value, handleChange, children, id, formControlClassName, dropdownClassName, disabled, placeholder, }) => {
    const classes = useStyles();
    const outlinedInputClasses = useOutlinedInputStyles();
    const generateMenuItems = () => {
        return children.map((child) => {
            return (react_1.default.createElement(core_1.MenuItem, { key: child.value, value: child.value, className: classes.menuItem, disableRipple: true },
                child.displayName,
                react_1.default.createElement(icons_1.Check, { className: classes.checkIcon })));
        });
    };
    return (react_1.default.createElement(core_1.FormControl, { variant: "outlined", className: formControlClassName, disabled: disabled },
        react_1.default.createElement(core_1.Select, { id: id, value: value, onChange: handleChange, className: (0, clsx_1.default)(classes.dropdown, dropdownClassName), input: react_1.default.createElement(core_1.OutlinedInput, { classes: outlinedInputClasses }), IconComponent: icons_1.ExpandMore, inputProps: {
                classes: {
                    icon: classes.icon,
                    root: classes.menuItem,
                },
                'data-testid': `${id}-input`,
            }, MenuProps: {
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                },
                getContentAnchorEl: null,
                classes: {
                    paper: classes.root,
                },
                PaperProps: {
                    id: `${id}-dropdown`,
                },
            }, displayEmpty: true, renderValue: value !== ''
                ? undefined
                : () => react_1.default.createElement("div", { className: classes.placeholder }, placeholder) }, generateMenuItems())));
};
exports.default = SingleSelectDropdown;
